import { render, staticRenderFns } from "./section-editor.vue?vue&type=template&id=108f65e1&scoped=true"
import script from "./section-editor.vue?vue&type=script&lang=ts"
export * from "./section-editor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108f65e1",
  null
  
)

export default component.exports